import {Injectable} from '@angular/core';
import {FormActionHandlerService} from './base.service';
import {SwalService} from '../../../fastlane-common/services/swal.service';
import {FormShareService} from '../share.service';
import {FormEmailService} from '../email.service';
import {UserContextService} from '../../../user/services/user-context.service';
import { formTypes } from 'app/form/form.constants';

@Injectable()
export class RequestPaymentFormActionHandlerService extends FormActionHandlerService {

  constructor(
    private emailService: FormEmailService,
    private shareService: FormShareService,
    private swal: SwalService,
    private userContext: UserContextService
  ) {
    super();
  }

  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      that.swal.radio({title: 'Select Paying Contact'}, that.getSwalOptions())
        .then(payingContactEmail => {
          that.swal.load(
            'Sending Payment Request Email...',
            `The selected contact will be notified to pay for this form's processing fee.`);

          if (that.shareService.form.type === formTypes.balanceAdjustmentRequest.abbrev) {
            that.emailService.sendAdditionalPaymentRequestedEmail(payingContactEmail)
              .subscribe(
                () => that.swal.success({
                  title: 'Email Sent',
                  text: 'The selected contact has been notified to make an additional payment on this project.'
                }).then(resolve).catch(resolve),
                () => reject('An error occurred while sending an email to the selected contact.')
              );
          } else {
            that.emailService.sendPaymentRequiredEmail(payingContactEmail).subscribe(
              () => that.swal.success({
                title: 'Email Sent',
                text: 'The selected contact has been notified to make a payment for the processing of this form.'
              }).then(resolve).catch(resolve),
              () => reject('An error occurred while sending an email to the selected contact.')
            );
          }
        }).catch(resolve);
    });
  }

  getSwalOptions() {
    const currentUserEmail = this.userContext.currentUser.emailAddress;
    const otherContacts = this.shareService.project.projectContacts.filter(contact => contact.emailAddress !== currentUserEmail);
    const formattedContacts = otherContacts.map(contact => {
      return {
        key: contact.emailAddress,
        value: `${contact.fullName()} (${contact.emailAddress})`
      };
    });
    return formattedContacts.reduce((previous, current) => {
      previous[current.key] = current.value;
      return previous;
    }, {});
  }

}
